import React from 'react';

// Lightweight, dependency-free bar chart (no chart library is installed in
// this project) shared by the desktop and mobile Admin stats pages.
// data: [{ key, label, value }]
const BarChart = ({ data, color = '#094268', height = 180 }) => {
  const max = Math.max(1, ...data.map((d) => d.value));

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'flex-end',
        gap: '10px',
        height: height + 44,
        overflowX: 'auto',
        padding: '0 4px 4px',
      }}
    >
      {data.map((d) => (
        <div
          key={d.key}
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            minWidth: '38px',
            flex: '1 0 auto',
          }}
        >
          <div style={{ fontSize: '12px', fontWeight: 700, marginBottom: '4px', color: '#333' }}>
            {d.value}
          </div>
          <div
            title={`${d.label}: ${d.value}`}
            style={{
              width: '26px',
              height: `${Math.max(2, (d.value / max) * height)}px`,
              backgroundColor: color,
              borderRadius: '3px 3px 0 0',
              transition: 'height 0.3s ease',
            }}
          />
          <div style={{ fontSize: '11px', color: '#666', marginTop: '6px', whiteSpace: 'nowrap' }}>
            {d.label}
          </div>
        </div>
      ))}
    </div>
  );
};

export default BarChart;
